import { render, staticRenderFns } from "./newoutperson.vue?vue&type=template&id=3f6208c2&scoped=true&"
import script from "./newoutperson.vue?vue&type=script&lang=js&"
export * from "./newoutperson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6208c2",
  null
  
)

export default component.exports